import { callQueryClientMethodWithQueryFilters } from '../lib/callQueryClientMethodWithQueryFilters.js';

function isFetching(qraftOptions, schema, args) {
    return callQueryClientMethodWithQueryFilters('isFetching', schema, args);
}

export { isFetching };
//# sourceMappingURL=isFetching.js.map
